import React from "react";

export default function Add({
  fill = "white",
  width = "32",
  height = "32",
  ...others
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 32 32'
      fill='none'
      {...others}
      xmlns='http://www.w3.org/2000/svg'>
      <g filter='url(#filter0_d_5811_156032)'>
        <path
          d='M4 8C4 3.58172 7.58172 0 12 0H20C24.4183 0 28 3.58172 28 8V16C28 20.4183 24.4183 24 20 24H12C7.58172 24 4 20.4183 4 16V8Z'
          fill='#296218'
        />
        <path
          d='M11.3333 18H20.6667C21.0203 18 21.3594 17.8595 21.6095 17.6095C21.8595 17.3594 22 17.0203 22 16.6667V7.33333C22 6.97971 21.8595 6.64057 21.6095 6.39052C21.3594 6.14048 21.0203 6 20.6667 6H11.3333C10.9797 6 10.6406 6.14048 10.3905 6.39052C10.1405 6.64057 10 6.97971 10 7.33333V16.6667C10 17.0203 10.1405 17.3594 10.3905 17.6095C10.6406 17.8595 10.9797 18 11.3333 18ZM13.3333 13.3333L14.9087 14.9087L17.3333 11.3333L20.6667 16H11.3333L13.3333 13.3333Z'
          fill='white'
        />
      </g>
      <defs>
        <filter
          id='filter0_d_5811_156032'
          x='0'
          y='0'
          width='32'
          height='32'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'>
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='4' />
          <feGaussianBlur stdDeviation='2' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.847059 0 0 0 0 0.847059 0 0 0 0 0.847059 0 0 0 0.15 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_5811_156032'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_5811_156032'
            result='shape'
          />
        </filter>
      </defs>
    </svg>
  );
}
